import './Stats.css';

import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';

import Menu from '../../components/HamburgerMenu';
import FPOImage from '../../components/FPOImage';

import useSession from '../../hooks/useSession';
import { getWithAuth } from '../../utils/api';

import header_stats from './PersonalScore_01_Header_2x.png';
import cta_stats from './PersonalScore_02_Headline_2x.png';
import insight_stats from './PersonalScore_03_InsightGarage_2x.png';
import agentic_stats from './PersonalScore_04_AgenticAccelerator_2x.png';
import racer_stats from './PersonalScore_05_AutoreelRacer_2x.png';
import footer_stats from './PersonalScore_06_Footer_2x.png';


let score_total = 0;

const OUTLINE_FPO = false;  // Set to true to see outlines on FPO images

function pullData(session, setTotalScore, setInsightsScore, setAutoreelScore, setAgenticScore) {
  //localStorage.clear();
  return getWithAuth(`/sessions/aggregate?userId=${session.id}`, session.authToken)
    .then((response) => response.json())
    .then((data) => {
      console.log('sessions:', data);
      if (data.length === 0)
      {
        setTotalScore(0);
        setInsightsScore(0);
        setAutoreelScore(0);
        setAgenticScore(0);
      }
      else
      {
        let total = 0;
        for (let i = 0; i < data.length; i++)
        {
          if (data[i].activity === 'AutoreelRacer')
          {
            setAutoreelScore(data[i].result);
          }
          if (data[i].activity === 'InsightsGarage')
          {
            setInsightsScore(data[i].result);
          }
          if (data[i].activity === 'AgenticAccelerator')
          {
            setAgenticScore(data[i].result);
          }

          total += data[i].result;
        }

        setTotalScore(total);
      }
    })
    .catch((error) => console.error('Error:', error));
}

function Stats() {
  const navigate= useNavigate();
  const { session } = useSession();
  
  const displayName = session?.display || 'Jessica';

  let [totalScore, setTotalScore] = useState(score_total);
  let [insightsScore, setInsightsScore] = useState(0);
  let [autoreelScore, setAutoreelScore] = useState(0);
  let [agenticScore, setAgenticScore] = useState(0);

  // Run once when the component loads: set name from localStorage and pull data
  useEffect(() => {
    if (!session) {
      navigate('/', { replace: true });  // Redirect to home if no session
    } else {
      pullData(session, setTotalScore, setInsightsScore, setAutoreelScore, setAgenticScore);
    }
  }, [session, navigate]);

  return (
    <div className="page">
      <Menu />
      <FPOImage src={header_stats} height={802} isOutlined={OUTLINE_FPO}>
        <div className="stats-name-and-total-points">
          {displayName},<br />
          <span style={{color: "white"}}>YOU'VE EARNED</span><br/>
          {totalScore}<br />
          STAR POINTS
        </div>
      </FPOImage>
      <FPOImage src={cta_stats} height={222} isOutlined={OUTLINE_FPO} />
      <FPOImage src={insight_stats} height={978} isOutlined={OUTLINE_FPO}>
        <div className="stats-points insight-points">{insightsScore} PTS</div>
      </FPOImage>
      <FPOImage src={racer_stats} height={948} isOutlined={OUTLINE_FPO}>
        <div className="stats-points autoreel-points">{autoreelScore} PTS</div>
      </FPOImage>
      <FPOImage src={agentic_stats} height={1021} isOutlined={OUTLINE_FPO}>
        <div className="stats-points agentic-points">{agenticScore} PTS</div>
      </FPOImage>
      <FPOImage src={footer_stats} height={387} isOutlined={OUTLINE_FPO} />
    </div>
  );
}

export default Stats;